import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as ReportCloneActions from './report-clone.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ReportResource } from '@mode/shared/data-access-webapp';

export const REPORT_CLONE_FEATURE_KEY = 'reportClone';
export interface ReportCloneEntityState {
  progressToastId?: number | null;
  reportId: string;
  loaded: boolean; // has the ReportClone list been loaded
  error?: string | null; // last known error (if any)
}

export interface ReportCloneState {
  reportCloneEntities: EntityState<ReportCloneEntityState>;
  recentlyClonedReport: ReportResource | null;
}

export const reportCloneAdapter: EntityAdapter<ReportCloneEntityState> = createEntityAdapter<ReportCloneEntityState>({
  selectId: (state) => state.reportId,
});

export const initialReportCloneState: ReportCloneState = {
  reportCloneEntities: reportCloneAdapter.getInitialState(),
  recentlyClonedReport: null,
};

const reportCloneEntitiesReducer = createReducer(
  initialReportCloneState.reportCloneEntities,
  on(ReportCloneActions.initReportClone, (state, action) =>
    reportCloneAdapter.upsertOne({ loaded: false, reportId: action.reportId }, state)
  ),
  on(ReportCloneActions.reportCloneInProgress, (state, { reportId, progressToastId }) =>
    reportCloneAdapter.upsertOne({ reportId, progressToastId, loaded: false }, state)
  ),
  on(ReportCloneActions.reportCloneSuccess, (state, { reportId }) =>
    reportCloneAdapter.upsertOne({ reportId, loaded: true }, state)
  ),
  on(ReportCloneActions.reportCloneFailed, (state, { reportId }) =>
    reportCloneAdapter.upsertOne({ reportId, loaded: true }, state)
  )
);

const clonedReportsReducer = createReducer(
  initialReportCloneState.recentlyClonedReport,
  on(ReportCloneActions.clonedReportLoaded, (_, { clonedReport }) => clonedReport)
);

export const reportCloneReducer: ActionReducerMap<ReportCloneState> = {
  reportCloneEntities: reportCloneEntitiesReducer,
  recentlyClonedReport: clonedReportsReducer,
};

export const { selectAll, selectEntities, selectIds, selectTotal } = reportCloneAdapter.getSelectors();
